import React, { useCallback } from 'react';
import { Box, Stack, Divider, Chip } from '@mui/material';
import CircleIcon from '@mui/icons-material/Circle';

// MUI에서 지원되는 색상 키워드만 사용했는지 확인합니다.
const tradeTypes = [
  { id: 1, value: '매출처', label: '매출처', color: 'primary' },
  { id: 2, value: '매입처', label: '매입처', color: 'secondary' },
  { id: 3, value: '제조사', label: '제조사', color: 'info' },
];

const PartnerStatusBox = ({ filters, onFilters }) => {
  // filters.searchTradeTyp이 undefined일 수 있으니 기본값을 빈 배열로 설정
  const selected = Array.isArray(filters.searchTradeTyp)
    ? filters.searchTradeTyp
    : [];

  // 클릭한 항목이 있으면 제거, 없으면 추가
  const handleToggleType = useCallback(
    (value) => {
      const next = selected.includes(value)
        ? selected.filter((v) => v !== value)
        : [...selected, value];
      onFilters('searchTradeTyp', next);
    },
    [selected, onFilters]
  );

  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'flex-end',
        alignItems: 'center',   // ❗ alignItem → alignItems
        m: 1,
      }}
    >
      <Stack
        direction="row"
        divider={<Divider orientation="vertical" flexItem />}
        spacing={2}
      >
        {tradeTypes.map(({ id, value, label, color }) => (
          <Chip
            key={id}                     // ❗ index 대신 안정적인 key(id) 사용
            icon={<CircleIcon />}
            label={label}
            variant={selected.includes(value) ? 'contained' : 'outlined'}
            color={selected.includes(value) ? color : 'default'}
            onClick={() => handleToggleType(value)}
            aria-label={`${label} 필터 토글`}  // 접근성 강화
            sx={{ mr: 1 }}
          />
        ))}
      </Stack>
    </Box>
  );
};

export default PartnerStatusBox;